import BuchhaltungTemplate from './templates/BuchhaltungTemplate';
import { BUCHHALTUNG_CONFIG } from './config/buchhaltung';

export default function BuchhaltungOesterreich() {
  return <BuchhaltungTemplate cfg={BUCHHALTUNG_CONFIG.AT} />;
}
